exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ClubEventCard-e8826d91{text-align:left}.header-780a7f38{background:#6982FF;color:#FFF;font-weight:500;padding-top:10px;padding-bottom:10px;padding-left:15px;padding-right:15px;font-size:15px;width:350px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border-radius:4px 4px 0 0}.content-0c14687b{font-size:14px;line-height:20px;padding:10px;width:350px;display:flex;flex-direction:row;text-align:left}.left-8ea45be0{flex:1 0 230px}.right-c367620c{flex:1 0 100px;height:100px}.timespan-d6043de2{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"ClubEventCard": "ClubEventCard-e8826d91",
	"header": "header-780a7f38",
	"content": "content-0c14687b",
	"left": "left-8ea45be0",
	"right": "right-c367620c",
	"timespan": "timespan-d6043de2"
};